export default __webpack_public_path__ + "static/news-section-people-image-06b6cc3b6994e443bbc1bc5518acd649.webp";